import React from 'react';
import { Flex } from '@banhala/ui-kit';
import { PiecesInfo } from './components/PiecesInfo';
import { DefaultInformation } from './components/DefaultInformation';
import { PIPNInfo } from './components/PIPNInfo';
import { SellerInfo } from './components/SellerInfo';
import { ModelInfo } from './components/ModelInfo';
import { WashingGuide } from './components/WashingGuide';

interface ProductInfoProps {
  hideOnEmpty?: boolean;
}

export const ProductInfo: React.FC<ProductInfoProps> = ({ hideOnEmpty }) => {
  return (
    <Flex>
      <PiecesInfo hideOnEmpty={hideOnEmpty} />
      <DefaultInformation />
      <PIPNInfo />
      <SellerInfo />
      <ModelInfo />
      <WashingGuide />
    </Flex>
  );
};
